import {_} from 'lodash';
import {TSyncfield_User} from "../../../constants/Syncfields";
import {IKnockoutComponent, IObjectData, ISyncField} from "../../../index";
import {getEmailLink, getRawSyncFieldValue, getSyncField, getTelLink, stripHtml} from "../../../util/misc";
import {getPrettyDateTime} from "../../../util/datetime";
import {nsSyncFields} from "../../../req/nsSyncFields";
import view_valueHtml from './view-value.html?raw';

export const template = view_valueHtml;

interface IValueViewParams {
    name: TSyncfield_User

    // either should be defined
    object?: IObjectData
    value?: ISyncField['value']
}

export class viewModel {
    private readonly syncfield: ISyncField | undefined;
    private readonly name: TSyncfield_User;
    private readonly value: ISyncField['value'] = '';
    private readonly object: IObjectData | undefined;

    constructor(params: IValueViewParams) {
        this.name = params.name;
        this.object = params.object;
        if (this.object) {
            this.syncfield = getSyncField(this.name, this.object.syncfields);
            this.value = getRawSyncFieldValue(this.name, this.object.syncfields) ?? '';
        }
        if (params.value !== undefined) {
            this.value = params.value;
        }
    }

    private getMarkup(): string {
        const value = stripHtml(this.value);
        if (!this.syncfield) {
            return value;
        }
        switch(this.syncfield.fieldtype) {
            case 'DateTime':
                return getPrettyDateTime(value);
        }

        switch (this.name) {
            case 'TelephoneNumber':
            case 'WorkPhone':
                return getTelLink(value);
            case 'Mobile':
            case 'PrivatePhone':
                return getTelLink(value, 'fa-mobile');
            case 'Email':
            case 'Mail':
            case 'PrivateEmail':
                return getEmailLink(value);
            case 'ALeaveFromDate':
            case 'ALeaveToDate':
            case 'APositionEndDate':
            case 'APositionStartDate':
            case 'AeduPositionEndDate':
            case 'AeduPositionStartDate':
            case 'AenrollmentEndDate':
            case 'AenrollmentStartDate':
            case 'AzureAdLastLogon':
            case 'Birthdate':
            case 'Start':
            case 'Stop':
                return getPrettyDateTime(value);
            default:
                return value;
        }
    }

    private static readonly NameIdPairs: Partial<Record<TSyncfield_User, TSyncfield_User>> = {
        'AUnitName': 'AUnitId',
        'AUnitId': 'AUnitName',
        'AeduPositionOrgName': 'AeduPositionOrgId',
        'AeduPositionOrgId': 'AeduPositionOrgName',
        'AenrollmentOrgName': 'AenrollmentOrgId',
        'AenrollmentOrgId': 'AenrollmentOrgName',
    } as const

    private getComponent(index: number | null = null): IKnockoutComponent | null {
        if (!this.object || !this.syncfield) {
            return null;
        }

        const pairedName = viewModel.NameIdPairs[this.name];
        let syncfield: ISyncField | undefined = pairedName
            ? getSyncField(pairedName, this.object.syncfields)
            : this.syncfield;

        if (!syncfield) {
            return null;
        }

        if (index !== null) {
            const resolved = _.cloneDeep(syncfield);
            resolved.value = nsSyncFields.getArrayByString(resolved.value)[index];
            syncfield = resolved;
        }
        return nsSyncFields.getDerivedValueComponent(syncfield!, {
            objectTypeId: this.object.type.id,
            linkable: true,
            object: this.object,
            showIcon: true,
        }) ?? null;
    }

    private getArrayByString() {
        return nsSyncFields.getArrayByString(this.value);
    }

    private getIcon(): string {
        switch (this.name) {
            case 'UserName':
                return 'fa-user';
            case 'Upn':
                return 'fa-database';
            default:
                return '';
        }
    }

}
